export const sortValuesAlphabetically = (filters: Array<string>): Array<string> => filters.sort()
